export default "/images/vendor/flag-icon-css/flags/4x3/mc.svg?b5edb75519037dcf483e8d845b7af989";